module.exports = __webpack_public_path__ + "img/full.1734f0d4.png";